import ModuleBase from '../shared/ModuleBase.js';

/**
 * Logo4 — Random Logo Display
 * Zeigt genau 8 zufaellige Logos aus allen hochgeladenen Logos an
 */
export default class Logo4 extends ModuleBase {
    constructor(el) {
        super(el);
        this._init();
    }

    _init() {
        const logoContainer = this.$el.querySelector('[data-logo-container]');
        if (!logoContainer) return;

        const allLogos = Array.from(logoContainer.querySelectorAll('.logo-item'));
        if (allLogos.length === 0) return;

        const displayCount = Math.min(8, allLogos.length);
        const shuffled = this._shuffle(allLogos);
        const selected = shuffled.slice(0, displayCount);

        selected.forEach((logo) => {
            logo.style.display = 'flex';
        });
    }

    /**
     * Fisher-Yates Shuffle
     */
    _shuffle(array) {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    }
}
